import { createContext } from 'react';

export const MountPointContext = createContext({
    popover: null as unknown as HTMLDivElement,
    shadowRoot: null as unknown as ShadowRoot,
});
